import { Directive, TemplateRef } from '@angular/core';
import { SgSecuritiesPieComponent, SgSecuritiesPieTemplateContext } from './securities-pie.component';

@Directive({
  selector: '[sgDoughnutView]',
  standalone: false,
})
export class SgSecuritiesPieDoughnutViewDirective<T = any> {
  constructor(tpl: TemplateRef<SgSecuritiesPieTemplateContext<T>>, securitiesPie: SgSecuritiesPieComponent<T>) {
    securitiesPie.registerTemplate(tpl);
  }
}
